import React from 'react'
import { BlogWrap } from '../../wrapper';

const AnimatePage = () => {
  return (
    <div>Hello World</div>

  )
}

export default BlogWrap(AnimatePage, 'animation');